import getVisibleFieldIdsOfType, { getVisibleFieldsOfTypeById } from './get-visible-fields-of-widget.js';
import { WIDGET_TYPES } from '../constants.js';

/**
 * SB-9413: fields shown in an Agenda embed's session and subsession pop-ups.
 *
 * Agenda embeds load session values from the Agenda field selection, which can
 * hold any standard or custom session field. The pop-ups used to read only the
 * Session selection, so custom fields picked for the agenda never appeared.
 * The pop-up now shows the Agenda selection, followed by any Session-scope
 * fields saved on older embeds. A field in both scopes keeps its Session entry,
 * which is where a custom label lives.
 *
 * @param {Object} groupedFields
 * @returns {{ ids: string[], byId: Object }}
 */
const getAgendaModalFields = groupedFields => {
  const agendaIds = getVisibleFieldIdsOfType(groupedFields, WIDGET_TYPES.AGENDA);
  const sessionIds = getVisibleFieldIdsOfType(groupedFields, WIDGET_TYPES.SESSIONS);
  const ids = [...new Set([...agendaIds, ...sessionIds])];
  const byId = {
    ...getVisibleFieldsOfTypeById(groupedFields, WIDGET_TYPES.AGENDA),
    ...getVisibleFieldsOfTypeById(groupedFields, WIDGET_TYPES.SESSIONS),
  };
  return { ids, byId };
};

export default getAgendaModalFields;
